<template>
   <div class="col-lg-12">
      <div class="card">
         <div class="card-body">
            <b-tabs content-class="mt-3" nav-class="nav-tabs-custom">
               <b-tab active>
                  <template v-slot:title>
                     <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                     </span>
                     <span class="d-none d-sm-inline-block">Ventas Globales</span>
                  </template>
                  <load-spinner v-if="loading"></load-spinner>
                  <global-sales-table v-else :ventas="ventas" ></global-sales-table>
               </b-tab>
               <b-tab>
                  <template v-slot:title>
                     <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                     </span>
                     <span class="d-none d-sm-inline-block">Ventas por Familia</span>
                  </template>
                  <load-spinner v-if="loading"></load-spinner>
                  <family-sales-table v-else :ventas="ventas" ></family-sales-table>
               </b-tab>
            </b-tabs>
         </div>
      </div>
   </div>
</template>

<script>
   import LoadSpinner from '@/components/widgets/LoadSpinner'
   import GlobalSalesTable from '@/components/widgets/customers/global-sales-table'
   import FamilySalesTable from '@/components/widgets/customers/family-sales-table'
   import axios from 'axios'

   export default {
      name: 'Tabs-Widget',
      data () {
         return {
            loading: true,
            ventas: []
         }
      },
      components: { LoadSpinner, GlobalSalesTable, FamilySalesTable },
      async mounted () {
         let codcli = this.$route.params.codcli
         let coddep = this.$route.params.coddep
         let params = "json="+JSON.stringify({ 'codcli': codcli, 'coddep': coddep })

         await axios({url: 'https://portal.asein.es/api-v2/widget-tabs', data: params, method: 'POST' })
         .then(resp => {
            this.ventas = resp.data
         })
         .catch(err => {
            console.log(err)
         })
         this.loading = false
      }
   }
</script>